import React from 'react';
import {
  IconChatNotification, IconCursor, IconGlobeCursor, IconStore, IconThumb,
} from 'gatorcomponents';


export default {
  adsHandler: {
    firstRow: {
      tag: 'Con inteligencia artificial',
      title: '¡Crea anuncios que realmente venden en Facebook e Instagram!',
      list: [
        'Ahora tienes un agente de IA especializado en publicidad.',
        'Recibe ideas, textos y estrategias hechas a la medida de tu negocio.',
        'Llega a quienes importan, con menos esfuerzo y mejores resultados.',
      ],
      cta: 'Habla con el agente IA',
      ctaDescription: '¡Aprovecha! Está disponible en tu plan.',
    },
    secondRow: {
      title: '¡Descubre todo lo que el Agente IA de Marketing puede hacer por tu negocio!',
      faqItems: [
        {
          title: '¿Para quién es el Agente de Marketing?',
          content: {
            text: 'El Agente de Marketing es perfecto para pequeños y medianos emprendedores, trabajadores independientes y quienes están comenzando a hacer anuncios online. Está pensado para quienes quieren promocionar su negocio en Facebook e Instagram.',
          },
        },
        {
          title: '¿Qué hace este agente de IA?',
          content: {
            text: 'El agente entiende tu negocio, crea toda la estructura de la campaña en Facebook Ads y te explica todo de forma sencilla, sin que necesites ser experto en tráfico o segmentación.',
          },
        },
        {
          title: '¿Con qué tareas puede ayudarme el Agente de Marketing?',
          content: {
            title: 'Puede ayudarte a:',
            list: [
              'Entender tu negocio y público objetivo;',
              'Sugerir el mejor tipo de campaña, público, presupuesto y formato de anuncio para Facebook e Instagram;',
              'Crear textos e imágenes para tus anuncios;',
              /* 'Preparar todo el plan de campaña listo para el Administrador de Anuncios de Facebook;', */
              'Explicarte paso a paso cómo configurar y publicar tus anuncios;',
              'Orientarte sobre las políticas de Facebook, buenas prácticas y ajustes en la campaña;',
              'Sugerirte ideas para publicaciones, calendario de contenidos y otras estrategias digitales.',
              'Ayudarte a crear anuncios en HostGator Studio;',
              'Campañas de Email Marketing;',
            ],
          },
        },
        {
          title: '¿Cómo debo usar el Agente de Marketing?',
          content: {
            text: 'Solo cuéntale sobre tu negocio, qué quieres anunciar y a quién deseas vender. El agente te hará algunas preguntas sencillas, te sugerirá las mejores estrategias y te mostrará, paso a paso, cómo configurar y publicar tu campaña en el Administrador de Anuncios de Facebook. Solo tienes que seguir las instrucciones y, si lo necesitas, pedir ayuda para ajustes o resolver otras dudas.',
          },
        },
        // ITENS PROVISIORIAMENTE COMENTADOS
        /*         {
          title: '¿Qué información necesito para crear un anuncio?',
          content: {
            title: 'Solo tienes que decirle:',
            list: [
              'Qué vendes',
              'Cómo vendes (Instagram, WhatsApp, sitio web)',
              'Región/ciudad atendida',
              'Cuánto puedes invertir al mes',
              'Qué quieres anunciar',
            ],
            finishing: 'El agente sugerirá la mejor público, objetivo y formato de anuncio, explicándote el paso a paso.',
          },
        },
        {
          title: '¿Necesito saber crear anuncios o entender de Facebook Ads?',
          content: {
            text: '¡No! El agente te sugiere todo: desde el público hasta el presupuesto y los creativos.',
          },
        }, */
      ],
    },
    projects: {
      yourProjectsLabel: 'Tus proyectos',
      createNewProjectLabel: 'Crear nuevo proyecto',
      createdAt: ({ day, month }) => `Creado el ${day} de ${month}`,
    },
  },
  maiaLocales: {
    welcome: name => (
      <>
        <span>
          {`Hola ${name}, `}
        </span>
        ¿Qué deseas crear o promocionar hoy?
      </>
    ),
    suggestions: 'Si lo prefieres, elige una opción:',
    options: [
      {
        icon: IconGlobeCursor,
        label: 'Configurar Google Mi Negocio.',
        initialMessage: 'Ayúdame a configurar Google Mi Negocio',
        action: 'marketing',
      },
      {
        icon: IconThumb,
        label: 'Crear publicaciones para redes sociales',
        initialMessage: 'Ayúdame a crear publicaciones para redes sociales',
        action: 'marketing',
      },
      {
        icon: IconChatNotification,
        label: 'Promocionar ofertas en WhatsApp',
        initialMessage: 'Ayúdame a promocionar ofertas en WhatsApp',
        action: 'marketing',
      },
      {
        icon: IconCursor,
        label: 'Aumentar el compromiso',
        initialMessage: 'Ayúdame a aumentar mi compromiso',
        action: 'marketing',
      },
      {
        icon: IconStore,
        label: 'Crear artículos para blog',
        initialMessage: 'Ayúdame a crear artículos para mi blog',
        action: 'marketing',
      },
    ],
    askMaiaPlaceholder: 'Habla con Gator...',
  },
};
